const errorTemplate = (error) => {
  const errorCard = document.createElement('div');
  errorCard.id = 'js-bs-error';
  errorCard.className = 'barcode-scanner__error';

  const { code } = error || {};
  let title = '';
  let description = '';
  let actionText = '';

  /*
  ERROR CODES
  **** 400 - API call failed
  **** 404 - no products fround for matching sku
  **** 550 - user camera permissions denied
  */
  if (code === 403) {
    title = 'You Have Not Granted Access to Your Camera';
    description = 'Please allow access to the Camera to use the Barcode/QR Code Scanner';
  } else {
    title = 'We were unable to find a match';
    description = 'Try again or try searching with the SKU, model, or barcode number.';
    actionText = 'Tap to try again';
  }

  let innerHTML = `
    <span class="barcode-scanner__error--padded">
      <img
      src="https://assets.homedepot-static.com/images/v1/alert-error-red.svg"
      alt="error"
      class="barcode-scanner__icon--error"/>
      <span class="barcode-scanner__error--bold u__bold">${title}</span>
    </span>
    <span class="barcode-scanner__error--padded">${description}</span>
    <button class="barcode-scanner__error--centered" id="resetBarcodeScanner">${actionText}</button>`;

  errorCard.innerHTML = innerHTML;
  return errorCard;
};
export default errorTemplate;
